var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMexcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0257 13.4861L22.6466 2.42123C21.2483 0.114328 17.8381 0.0907279 16.4882 2.51917L9.79048 14.0265C8.53968 16.1364 10.0855 18.7855 12.5883 18.7855H26.0084C28.5348 18.7855 30.424 16.062 29.0257 13.4861Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8242 14.3455L19.4313 13.6587C19.0631 13.0203 18.2537 11.6468 18.2537 11.6468L12.8563 2.27406C11.458 0.189003 8.14578 0.0167223 6.74748 2.64222L0.466339 13.5112C-0.83402 15.7933 0.711779 18.761 3.53316 18.7858H16.8801H22.5725H25.9579C22.4993 18.8106 21.3948 17.0193 19.8242 14.3455Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8268 14.3445L19.4338 13.6577C19.0657 13.0194 18.2562 11.6458 18.2562 11.6458L14.7716 5.51221L9.76608 14.0507C8.51528 16.1605 10.0611 18.8108 12.5627 18.8108H16.8567H22.549H25.9592C22.4759 18.7848 21.3962 17.0184 19.8268 14.3445Z",
    fill: "url(#paint0_linear_1084_16237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1084_16237",
    x1: 8.3045,
    y1: 10.1771,
    x2: 22.8422,
    y2: 15.8934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexcLogo);
export default __webpack_public_path__ + "static/media/mexc-logo.82dcee28.svg";
export { ForwardRef as ReactComponent };